<template>
	<div class="new-user-wellcome-dialog">
		<div class="wellcome-dialog" v-show="signStep == 1">
			<p>完善信息，开启高效办公</p>
			<div class="section-title">你计划和多少人一起使用亿方云？</div>
			<div class="section-content enterprise-scale">
				<div
          :class="['item', index === selectIndex && 'active']"
					:data-scale="item.type" :data-value="item.scale"
					v-for="(item, index) of scaleList"
					:key="item.scale"
					@click="selectIndexFn(index)">
            {{item.text}}
				</div>
			</div>
			<div v-show="showName" class="team-name">
				<p>{{nameText}}</p>
				<input type="text" :placeholder="nameTextInput" maxlength="4" v-model="name">
			</div>
			<div :class="['submit-btn', canSubmit && 'active']" @click="submit()">
				下一步
			</div>
		</div>
		<div class="wellcome-dialog wellcome-dialog-step" v-show="signStep == 2">
      <p>选择所在行业</p>
      <div class="section-title">获取专属行业解决方案</div>
      <div class="popover-profession-container">
        <div :class="['item', professionIndex == professionSelectIndex && 'active']" v-for="(professionItem, professionIndex) of professionList" :key="professionIndex" @click="handleSelectProfessionItem(professionIndex)">
            <div>
                <p>{{professionItem.title}}</p>
                <span>{{professionItem.description}}</span>
            </div>
            <img :src="professionItem.bg" :alt="professionItem.title" />
        </div>
        <div class="add-item">
            <div :class="['container-customize', professionSelectIndex == 100 && 'active']" v-show="professionName" @click="handleSelectProfessionItem(100)">
                <span>{{professionName}}</span>
            </div>
            <div class="container" v-show="!professionName && !showProfessionInput" @click="handleAddProfession()">
                <i class="iconfont icon-a-add2"></i>
                <span>添加自定义</span>
            </div>
            <div class="input-item" v-show="!professionName && showProfessionInput">
                <input placeholder="自定义行业名称" type="text" v-model="writeProfessionName"  maxlength="4"/>
                <i :class="['iconfont icon-close', writeProfessionName && 'active']" @click="handleConfirm()" />
                <i class="iconfont icon-a-close1" @click="handleClose()" />
            </div>
        </div>
      </div>
			<div :class="['submit-btn', professionSelectIndex >= 0 && 'active']" @click="submit()">
				立即开启
			</div>
		</div>
	</div>
</template>
<script>

import { REGISTER_INDUSTRY_INFO, NEW_HOMEPAGE_DATA } from '@/config/api'
import ajax from '@/utils/ajax'

export default {
  name: 'WellcomeDialog',
  props: {

  },
  data () {
    return {
      scaleList: [{
        text: '2-5',
        scale: '2',
        type: 'team'
      }, {
        text: '6-10',
        scale: '3',
        type: 'team'
      }, {
        text: '11-30',
        scale: '4',
        type: 'team'
      }, {
        text: '31-50',
        scale: '5',
        type: 'team'
      }, {
        text: '50-200',
        scale: '6',
        type: 'enterprise'
      }, {
        text: '201-1000',
        scale: '7',
        type: 'enterprise'
      }, {
        text: '1000以上',
        scale: '8',
        type: 'enterprise'
      }, {
        text: '个人用',
        scale: '1',
        type: 'personal'
      }],
      selectIndex: -1,
      name: '',
      signStep: 1,
      professionList: [{}],
      professionName: '',
      showProfessionInput: false,
      writeProfessionName: '',
      professionSelectIndex: -1
    }
  },
  created () {
    ajax({
      url: NEW_HOMEPAGE_DATA
    })

    ajax({
      url: REGISTER_INDUSTRY_INFO
    }).then(res => {
      if (res && res.success) {
        this.professionList = res.enterprise_register_industry_info
      }
    })
  },
  computed: {
    showName () {
      return this.selectIndex > -1
    },
    nameText () {
      const textList = {
        'team': '你们的团队叫什么？',
        'enterprise': '你们来自哪家企业？',
        'personal': '该怎么称呼你？'
      }
      return this.selectIndex > -1 ? textList[this.scaleList[this.selectIndex].type] : '你们的团队叫什么？'
    },
    nameTextInput () {
      const textList = {
        'team': '请输入你们的团队名称',
        'enterprise': '请输入你们的企业名称',
        'personal': '请输入你的名字'
      }
      return this.selectIndex > -1 ? textList[this.scaleList[this.selectIndex].type] : '请输入你们的团队名称'
    },
    canSubmit () {
      return this.selectIndex > -1 && this.name
    }
  },
  watch: {
  },
  mounted () {

  },
  methods: {
    selectIndexFn (index) {
      this.selectIndex = index
    },
    handleAddProfession () {
      this.showProfessionInput = true
    },
    handleConfirm () {
      if (!this.writeProfessionName) {
        return
      }
      this.professionName = this.writeProfessionName
      this.showProfessionInput = false
      this.professionSelectIndex = 100
    },
    handleClose () {
      this.showProfessionInput = false
    },
    handleSelectProfessionItem (index) {
      this.professionSelectIndex = index
    },
    submit () {
      if (this.signStep === 1) {
        if (!(this.selectIndex > -1) || !this.name) {
          return
        }
        this.signStep = 2
        return
      }

      if (this.signStep === 2 && !(this.professionSelectIndex >= 0)) {
        return
      }

      let professionData = this.professionSelectIndex === 100 ? {
        title: this.professionName,
        description: '提供文件安全管理、员工安全管控、<br/>高效办公协作等服务',
        bg: 'https://p2.ssl.qhimg.com/t11b673bcd6f504898a7acc9bf5.png',
        type: 'CustomerIndustry'
      } : this.professionList[this.professionSelectIndex]

      this.$emit('wellcome-submut', this.name, this.scaleList[this.selectIndex].type, this.scaleList[this.selectIndex].scale, professionData)
    }
  }
}
</script>
<style lang="postcss" scoped>
	@import 'variables';

	.new-user-wellcome-dialog {
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 10000;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.50);
		display: flex;
		flex-direction: column;
		justify-content: flex-end;

		& .wellcome-dialog {
			background: #FFF;
			padding: 32px 24px;

			& > p {
				color: #252E36;
				font-family: PingFang SC;
				font-size: 22px;
				font-style: normal;
				font-weight: 600;
				line-height: 30px;
			}

			& .section-title {
				color: #999;
				font-family: PingFang SC;
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
				line-height: 22px;
				margin-top: 32px;
			}

			& .section-content {
				display: flex;
				flex-wrap: wrap;

				& .item {
					display: flex;
					width: 96px;
					height: 40px;
					justify-content: center;
					align-items: center;
					color: #10182E;
					font-family: PingFang SC;
					font-size: 16px;
					font-style: normal;
					font-weight: 400;
					line-height: 24px;
					box-sizing: border-box;
					border-radius: 4px;
					background: #F7F8F9;
					margin-top: 16px;
					margin-right: 12px;
					box-sizing: border-box;
					border: 1px solid #F7F8F9;

					&.active {
						border: 1px solid #017FFD;
						color: #017FFD;
						background: #006BFF;
						color: #FFF;
					}

					&:nth-child(3n) {
						margin-right: 0;
					}
				}
			}

			& .team-name {
				margin-top: 32px;

				& > p {
					color: #999;
					font-family: PingFang SC;
					font-size: 14px;
					font-style: normal;
					font-weight: 400;
					line-height: 22px;
				}

				& > input {
					display: flex;
					width: 100%;
					height: 50px;
					align-items: center;
					border: none;
					padding: 0 8px;
					color: #10182E;
					font-family: PingFang SC;
					font-size: 16px;
					font-style: normal;
					font-weight: 400;
					box-sizing: border-box;
					margin-top: 12px;
					border-radius: 8px;
					background: #F9FAFC;

					&::placeholder {
						color: #B2B7CA;
					}
				}
			}

			& .after-profession-container {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 100%;
				height: 50px;
				padding: 0px 12px;
				margin-top: 12px;
				border-radius: 8px;
				background: #F9FAFC;
				margin-bottom: 24px;
				cursor: pointer;
				box-sizing: border-box;

				> div {
					display: flex;
					align-items: center;
				}

				& .placeholder-text {
					color: #B2B7CA;
					font-family: "PingFang SC";
					font-size: 14px;
					font-style: normal;
					font-weight: 400;

					span {
						font-size: 12px;
						margin-left: 8px;
					}
				}

				& .text {
					font-size: 14px;
					line-height: 1;
					color: #252e36;
				}
			}

			& .submit-btn {
				display: flex;
				height: 40px;
				justify-content: center;
				align-items: center;
				border-radius: 4px;
				opacity: 0.3;
				background: #017FFD;
				color: #FFF;
				font-family: PingFang SC;
				font-size: 16px;
				font-style: normal;
				font-weight: 600;
				line-height: 26px;
				margin-top: 48px;

				&.active {
					opacity: 1;
				}
			}
		}

    & .wellcome-dialog-step {
      .section-title {
        margin-top: 8px;
      }

      & .popover-profession-container {
        width: 100%;
        display: flex;
				align-items: center;
        margin-top: 32px;
        flex-direction: column;
        box-sizing: border-box;

        & .item {
          display: flex;
          align-items: center;
          width: 100%;
          height: 72px;
          padding: 12px 16px;
          box-sizing: border-box;
          border-radius: 8px;
          cursor: pointer;
          position: relative;
          margin-bottom: 12px;
          background: #F5F9FF;

          & > div {
            & p {
              color: #252E36;
              font-family: "PingFang SC";
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: 22px;
            }

            & span {
              color: #676E87;
              font-family: "PingFang SC";
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 20px;
            }
          }

          & img {
            display: flex;
            flex-shrink: 0;
            width: 52px;
            position: absolute;
            right: 13px;
            bottom: 0;
          }

          &.active {
            background: #E8F5FF;
          }
        }

        & .add-item {
          width: 100%;
          margin: 2px 0;

          & .container-customize {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            height: 44px;
            padding: 0px 16px;
            color: #1D2531;
            font-family: "PingFang SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            border-radius: 8px;
            background: #F5F9FF;
            box-sizing: border-box;
            cursor: pointer;

            &.active {
              background: #E8F5FF;
            }
          }

          & .container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 44px;
            padding: 0px 16px;
            color: #006BFF;
            font-family: "PingFang SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 1;
            cursor: pointer;
            border-radius: 4px;
            border: 1px solid #006BFF;
            background: #FFF;
            box-sizing: border-box;

            & i {
              font-size: 12px;
              color: #006BFF;
              margin-right: 12px;
            }
          }

          & .input-item {
            position: relative;

            & > input {
              width: 100%;
              height: 44px;
              padding: 0px 80px 0 12px;
              box-sizing: border-box;
              border-radius: 8px;
              border: 1px solid #1A65FF;
              color: #252E36;
              font-family: "PingFang SC";
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
            }

            & i {
              position: absolute;
              font-size: 24px;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
            }

            & .icon-a-close1 {
              right: 12px;
            }

            & .icon-close {
              font-size: 20px;
              right: 45px;
              color: #1A65FF;
              opacity: 0.3;

              &:before {
                position: relative;
                top: -4px;
              }

              &.active {
                opacity: 1;
              }
            }
          }
        }
      }

      & .submit-btn {
        margin-top: 35px;
      }
    }
	}
</style>
